/**
 * Uma licitação em página própria.
 *
 * Existe porque `/licitacao/8640742` pode ser mandado para alguém. O painel
 * anterior guardava o id no payload e nunca o usava: os cartões eram
 * endereçados por índice do array, então não havia link possível — para
 * mostrar uma licitação a um colega, era descrever onde rolar.
 */
import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { api, ErroApi } from "../api/cliente";
import { Migalhas } from "../componentes/Migalhas";
import { nomeLegivel } from "../formato";
import { Corpo } from "../componentes/PainelDetalhe";
import css from "./Licitacao.module.css";

export function Licitacao() {
  const { id = "" } = useParams();
  const { data, isPending, error } = useQuery({
    queryKey: ["licitacao", id],
    queryFn: () => api.detalhe(id),
  });

  if (isPending) return <p className={css.espera}>Carregando…</p>;

  if (error || !data) {
    const naoAchou = error instanceof ErroApi && error.status === 404;
    // A REGRA 1 tambem responde 404, e com o motivo no texto: a licitacao
    // existe, mas esta fora do fluxo de avaliacao (score abaixo de 50).
    const foraDoFluxo = naoAchou && /fora do fluxo/.test(error.message);
    return (
      <div className={css.erro}>
        <h1>
          {foraDoFluxo
            ? "Fora do fluxo de avaliação"
            : naoAchou
              ? "Essa licitação não está no acervo"
              : "Não deu para abrir"}
        </h1>
        <p>
          {foraDoFluxo
            ? error.message
            : naoAchou
            ? "O acervo só tem o que já foi varrido. Se o link veio de outra pessoa, pode ser que a varredura dela ainda não tenha chegado aqui."
            : error instanceof Error
              ? error.message
              : "erro desconhecido"}
        </p>
        <Link to="/oportunidades">Voltar para as oportunidades</Link>
      </div>
    );
  }

  return (
    <article className={`${css.pagina} ${css.larga}`}>
      {/* A TRILHA (20/10), no lugar do botão "← Oportunidades": alinhada ao
          conteúdo, diz onde se está, e vindo da lista o primeiro degrau é o
          voltar do navegador (a lista reaparece como estava). No celular some:
          a seta da barra de cima é o voltar. */}
      <Migalhas
        itens={[
          { rotulo: "Oportunidades", para: "/oportunidades" },
          // O CAMINHO DO LUGAR, como no Licitário: a UF e o município entre a
          // lista e a oportunidade. Só texto — a lista não filtra por URL.
          ...(data.uf ? [{ rotulo: data.uf }] : []),
          ...(data.municipio ? [{ rotulo: nomeLegivel(data.municipio) }] : []),
          { rotulo: `Oportunidade #${data.id}` },
        ]}
      />
      {/* O MESMO `Corpo` DO PAINEL LATERAL (19/10): as cinco abas, o score, as
          ações e o bloco de registrar a decisão são um componente só — o que
          muda aqui é a largura, e as colunas se reorganizam por ela. A aba
          aberta vem da URL (`?aba=`), e `key` dá a cada oportunidade o estado
          dela. O dossiê, que só esta página mostrava, está na aba "Documentos
          e evidências" dos dois. */}
      {/* DIRETO NA TELA (28/10): sem a folha de fundo em volta. A `.folha`
          continua para a ficha do atestado. */}
      <div className={css.direto}>
        <Corpo key={data.id} d={data} telaCheia />
      </div>
    </article>
  );
}
